import themeResource from "@/shared/resource/theme";
import { authorizedAxios,  } from "./authorizedAxios";
import {
  ManageThemesRequest,
  ManageThemesResponse,
  ThemeSearchRequest,
  ThemePagedResponse
} from "@/shared/types";
import { EmployerThemeRequest, EmployerThemeResponse, PartnerThemeRequest, PartnerThemeResponse } from "@/admin/types";

export function getAllThemes () {
  return authorizedAxios.get<ManageThemesResponse[]>(themeResource.getAllThemes());
}

export function getTheme (themeId: number) {
  return authorizedAxios.get<ManageThemesResponse>(themeResource.getTheme(themeId));
}

export function updateTheme (request: ManageThemesRequest) {
  return authorizedAxios.post<ManageThemesResponse>(themeResource.updateTheme(), request);
}

export function searchTheme (request: ThemeSearchRequest ) {
  return authorizedAxios.post<ThemePagedResponse>(themeResource.searchTheme(), request);
}


export function getPartnerTheme (partnerId: number | string) {
  return authorizedAxios.get<PartnerThemeResponse>(themeResource.getPartnerTheme(partnerId));
}

export function savePartnerTheme (request: PartnerThemeRequest) {
  return authorizedAxios.post<PartnerThemeResponse>(themeResource.savePartnerTheme(request.partnerId, request.themeId));
}

export function getEmployerTheme (employerId: number) {
  return authorizedAxios.get<EmployerThemeResponse>(themeResource.getEmployerTheme(employerId));
}

export function saveEmployerTheme (request: EmployerThemeRequest) {
  return authorizedAxios.post<string>(themeResource.saveEmployerTheme(), request);
}


export function deletePartnerTheme (request: PartnerThemeRequest) {
  return authorizedAxios.delete<PartnerThemeResponse>(themeResource
    .deletePartnerTheme(request.partnerId, request.partnerThemeId));
}

export function getActiveThemes () {
  return authorizedAxios.get<ManageThemesResponse[]>(themeResource.getActiveThemes());
}

export function getThemeForUser (employerId: number, partnerId: number) {
  return authorizedAxios.get<ManageThemesResponse>(themeResource.getThemeForUser(employerId, partnerId));
}
